export const SW_REDIRECT = 'sw-redirect'